import React from 'react';
import { useContent } from '../context/ContentContext';

export default function Ticker() {
  const { sections } = useContent();
  const items = (sections?.ticker_items || []).filter(Boolean);
  if (items.length === 0) return null;
  const list = [...items, ...items];
  return (
    <div className="ticker">
      <div className="ticker-track">
        {list.map((t, i) => (
          <span key={i}>
            <span className="dot" />
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
